import { BaseHand } from '../base-hand'
import { Card } from '../../card/card'
import { BestHand, TCalculatedHand } from '../best-hand'
import { EmptyHand } from './0-empty-hand'

export class ThreeOfAKind extends EmptyHand implements TCalculatedHand {
    hand_rank = 3
    hand_name = 'Three Of A Kind'

    constructor(base_hand: BaseHand) {
        super(base_hand)
    }

    isHand(): boolean {
        return this.base_hand.rank_triple.length >= 1
    }

    cardsInHand(): Card[] {
        return this.base_hand.cards_sorted
            .filter((c) => this.base_hand.rank_triple.includes(c.rank.value))
            .slice(0, 3)
    }

    cardsNotInHand(): Card[] {
        return this.base_hand.cards_sorted
            .filter((c) => !this.base_hand.rank_triple.includes(c.rank.value))
            .slice(0, 2)
    }

    eq(other: TCalculatedHand): boolean {
        if (this.hand_rank === other.hand_rank) {
            if (
                this.base_hand.rank_triple[0] === other.base_hand.rank_triple[0]
            ) {
                // Delegate to bestHand
                return new BestHand(this.cardsNotInHand()).hand.eq(
                    new BestHand(other.cardsNotInHand()).hand
                )
            }
        }
        return false
    }

    gt(other: TCalculatedHand): boolean {
        if (this.hand_rank > other.hand_rank) {
            return true
        } else if (this.hand_rank < other.hand_rank) {
            return false
        } else {
            if (
                this.base_hand.rank_triple[0] > other.base_hand.rank_triple[0]
            ) {
                return true
            } else if (
                this.base_hand.rank_triple[0] < other.base_hand.rank_triple[0]
            ) {
                return false
            } else {
                // Delegate to bestHand
                return new BestHand(this.cardsNotInHand()).hand.gt(
                    new BestHand(other.cardsNotInHand()).hand
                )
            }
        }
    }

    lt(other: TCalculatedHand): boolean {
        if (this.hand_rank < other.hand_rank) {
            return true
        } else if (this.hand_rank > other.hand_rank) {
            return false
        } else {
            if (
                this.base_hand.rank_triple[0] < other.base_hand.rank_triple[0]
            ) {
                return true
            } else if (
                this.base_hand.rank_triple[0] > other.base_hand.rank_triple[0]
            ) {
                return false
            } else {
                // Delegate to bestHand
                return new BestHand(this.cardsNotInHand()).hand.lt(
                    new BestHand(other.cardsNotInHand()).hand
                )
            }
        }
    }
}
